import { CONFIGURATIONS } from "../../config/envConfig";
import CustomButton from "../Form/CustomButton";
import { useNavigate } from "react-router-dom";

const Layout = ({ userType }) => {
  const navigate = useNavigate();

  const handleContactUsClick = () => {
    navigate("/contact-us");
  };

  const paragraph =
    userType === "staff"
      ? "We value your professional insights. Please use the form below to submit your review or suggestions regarding the care and support services at Roselea."
      : "Your feedback matters. Please share your thoughts on your loved one’s experience at Roselea using the form below.";

  const link =
    userType === "staff"
      ? "Staff are directed to the staff-specific form"
      : "Family members are directed to the family-specific form";

  const linkHref =
    userType === "staff"
      ? CONFIGURATIONS.FORM_NAVIGATION_STAFF
      : CONFIGURATIONS.FORM_NAVIGATION_CLIENT;

  return (
    <>
      <div
        className="w-full h-[300px] sm:h-[350px] lg:h-[450px] xl:h-[682px] bg-[#F6867A] flex flex-col text-center pt-[47px] lg:pt-[55px] xl:pt-[156px] font-poppins text-white"
        style={{ clipPath: "polygon(0 0, 100% 0, 100% 75%, 0 90%)" }}
      >
        <div className="text-[28px] lg:text-[42px] xl:text-[60px] uppercase">
          <p className="font-light"> Submit Your Review </p>
          <p className="font-semibold mt-[9px] lg:mt-[15px]">
            {" "}
            Roselea Care Facility{" "}
          </p>
        </div>

        <p className="text-level-7 lg:text-lg font-normal mt-[10px] lg:mt-[17px]">
          Your feedback helps us grow and provide the best care.
        </p>
      </div>

      <div className="font-poppins text-center">
        <div className="text-green font-semibold text-level-6 lg:text-level-2 xl:text-[36px] px-[20px] lg:px-[100px]">
          <p>{paragraph}</p>
        </div>
        <div
          className="text-level-7 lg:text-lg underline text-[#2563EB] mt-[50px] cursor-pointer hover:opacity-80 transition-opacity"
          onClick={(e) => {
            e.preventDefault();
            if (linkHref) {
              window.open(linkHref, "_blank");
            }
          }}
        >
          {link}
        </div>
        <div className="flex flex-col items-center space-y-4 my-[50px]">
          <CustomButton
            bgColor="bg-[var(--primary-orange-color)]"
            buttonText="Contact Us"
            width="w-36"
            textColor="text-white"
            textWeight="font-semibold"
            className="hover:bg-white hover:border-[var(--primary-orange-color)] hover:text-[var(--primary-orange-color)]"
            onClick={handleContactUsClick}
          />
        </div>
      </div>
    </>
  );
};
export default Layout;
